import { Box, SxProps, Theme, Typography, useTheme } from "@mui/material";
import React from "react";

const DKGlobalThemeGallery = () => {
  const theme = useTheme();

  const ColorExamples = () => {
    const palettes = [
      "primary",
      "secondary",
      "tertiary",
      "error",
      "warning",
      "info",
      "success",
    ];

    const shades = ["lighter", "light", "main", "dark", "darker"];

    const colors = palettes.map((palette) => {
      const shadesForPalette = shades.map((shade) => {
        return (
          <Box
            sx={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              margin: "10px",
              alignItems: "center",
            }}
            key={palette + shade}
          >
            <Box
              sx={{
                backgroundColor: theme.palette[palette][shade],
                margin: "10px",
                width: "100px",
                height: "100px",
                border: "1px solid lightgrey",
              }}
            ></Box>
            {palette}.{shade}
          </Box>
        );
      });

      return (
        <Box key={palette}>
          <Typography variant="h3">{palette}</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: "50px",
            }}
          >
            {shadesForPalette}
          </Box>
        </Box>
      );
    });

    return <Box>{colors}</Box>;
  };

  const TypographyExamples = () => {
    const variants = [
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "body1",
      "body2",
      "subtitle1",
      "subtitle2",
      "caption",
      "button",
      "overline",
    ];

    const texts = variants.map((variant) => {
      return (
        <Box sx={{ marginBottom: "20px" }} key={variant}>
          <Typography variant="h3">{variant}</Typography>
          {/* @ts-ignore */}
          <Typography variant={variant}>
            The quick brown fox jumps over the lazy dog
          </Typography>
        </Box>
      );
    });

    return <Box>{texts}</Box>;
  };

  const goToLinkContainer: React.CSSProperties = {
    display: "block",
    marginBottom: "10px",
  };

  const sectionContainer: SxProps<Theme> = {
    marginTop: "50px",
  };

  return (
    <Box sx={{ margin: "20px", marginBottom: "100px" }}>
      <Typography variant="h1">Dealkit Global Theme Gallery</Typography>
      <Typography variant="body1">
        This page provides visual examples of the Dealkit Global Theme
      </Typography>
      <Box sx={sectionContainer}>
        <Typography variant="h2">Go To</Typography>
        <a style={goToLinkContainer} href="#colors-section">
          Colors
        </a>
        <a style={goToLinkContainer} href="#typography-section">
          Typography
        </a>
      </Box>
      <Box sx={sectionContainer} id="colors-section">
        <Typography variant="h2">Colors</Typography>
        <ColorExamples />
      </Box>
      <Box sx={sectionContainer} id="typography-section">
        <Typography variant="h2">Colors</Typography>
        <TypographyExamples />
      </Box>
    </Box>
  );
};

export default DKGlobalThemeGallery;
